import * as types from "./actionTypes";

export function set(payload) {
  return {
    type: types.SET,
    payload: {
      endpoints: payload,
    },
  };
}
